import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'itfg-auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss'],
    standalone: false
})
export class AuthComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
